module.exports = __webpack_public_path__ + "media/04_ASANBUDAPEST-BEATS04.bf842fee.mp3";